// src/components/admin/CompletedOrders.jsx

import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    Box,
    Grid,
    Paper,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    CircularProgress,
    TextField,
} from '@mui/material';
import { setOrders, setStatus } from '../../features/ordersSlice';
import { GetOrder, UpdateOrder } from '../../utils/order';
import { GetAllStatus } from '../../utils/lookupUtil';
import AdminEditProductDialog from './AdminEditProductDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';
import { RemoveOrder } from '../../utils/order';


const CompletedOrders = () => {
    const dispatch = useDispatch();
    const orders = useSelector((state) => state.orders.orders);
    const status = useSelector((state) => state.orders.status);

    const [open, setOpen] = useState(false);
    const [orderDetails, setOrderDetails] = useState(null);

    const [nameFilter, setNameFilter] = useState('');
    const [dateFilter, setDateFilter] = useState('');

    const handleClose = () => setOpen(false);

    const GetOrderList = async () => {
        const data = await GetOrder();
        dispatch(setOrders(data));
    };

    const GetStatus = async () => {
        const data = await GetAllStatus();
        dispatch(setStatus(data));
    };

    useEffect(() => {
        if (!orders || orders.length === 0) {
            GetOrderList();
        }
        if (!status || status.length === 0) {
            GetStatus();
        }
    }, [dispatch]);

    if (!orders || orders.length === 0 || !status || status.length === 0) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" sx={{ p: 4 }}>
                <CircularProgress size={30} sx={{ mr: 5 }} />
                <Typography variant="h4" sx={{ mr: 5 }}>
                    טוען הזמנות שבוצעו...
                </Typography>
            </Box>
        );
    }

    // מוצאים את הסטטוס "בוצע" מתוך טבלת הסטטוסים
    const COMPLETED_STATUS_ID = 2;

    const completedOrders = orders.filter(
        (o) => Number(o.statusId) === Number(COMPLETED_STATUS_ID)
    );

    // מסנן לפי שם ותאריך
    const filteredOrders = completedOrders.filter((order) => {
        const matchName = order.user?.name
            ?.toLowerCase()
            .includes(nameFilter.toLowerCase());

        // order.date צריך להיות בפורמט ש-compatible עם input type="date" (למשל "2025-12-08")
        const matchDate = dateFilter
            ? String(order.date).startsWith(dateFilter)
            : true;

        return matchName && matchDate;
    });

    const clearDateFilter = () => {
        setDateFilter("");
    };


    const handleDetailsOrder = (order) => {
        setOrderDetails(order);
        setOpen(true);
    };

    const handleDeleteOrder = async (orderId) => {
        const confirmDelete = window.confirm("האם את בטוחה שברצונך למחוק את ההזמנה?");
        if (!confirmDelete) return;

        try {
            await RemoveOrder(orderId); // מחיקה מהשרת (DB)

            // עדכון ה־Redux – הסרת ההזמנה מהרשימה
            const updatedOrders = orders.filter(o => o.id !== orderId);
            dispatch(setOrders(updatedOrders));
        } catch (err) {
            console.error(err);
            alert("שגיאה במחיקת ההזמנה");
        }
    };


    console.log("orders:", orders);
    console.log("completedOrders:", completedOrders);
    // console.log("COMPLETED_STATUS_ID:", COMPLETED_STATUS_ID);

    return (
        <Box sx={{ flexGrow: 1, padding: 3 }}>
            {open && (
                <AdminEditProductDialog
                    open={open}
                    handleClose={handleClose}
                    order={orderDetails}
                />
            )}

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Paper sx={{ padding: 2 }}>
                        <Typography variant="h4" gutterBottom>
                            הזמנות שבוצעו
                        </Typography>

                        {/* 🔽 אזור מסננים */}
                        <Box sx={{ display: 'flex', gap: 2, mt: 2, mb: 2 }}>
                            <TextField
                                label="חיפוש לפי שם לקוח"
                                variant="outlined"
                                value={nameFilter}
                                onChange={(e) => setNameFilter(e.target.value)}
                                fullWidth
                            />

                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <TextField
                                    label="סינון לפי תאריך"
                                    type="date"
                                    value={dateFilter}
                                    onChange={(e) => setDateFilter(e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                />

                                <Button
                                    variant="text"
                                    color="error"
                                    onClick={clearDateFilter}
                                    sx={{ mt: 1 }}
                                >
                                    נקה תאריך
                                </Button>
                            </Box>
                        </Box>


                        <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        {/* <TableCell>ID</TableCell> */}
                                        <TableCell>שם לקוח</TableCell>
                                        <TableCell>תאריך</TableCell>
                                        <TableCell>סה&quot;כ</TableCell>
                                        <TableCell>לצפייה בהזמנה</TableCell>
                                        <TableCell>מחיקה</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredOrders.map((order) => (
                                        <TableRow key={order.id}>
                                            {/* <TableCell>{order.id}</TableCell> */}
                                            <TableCell>{order.user.name}</TableCell>
                                            <TableCell>{order.date}</TableCell>
                                            <TableCell>
                                                ₪{Number(order.totalCost).toFixed(2)}
                                            </TableCell>
                                            <TableCell>
                                                <Button
                                                    variant="outlined"
                                                    color="secondary"
                                                    onClick={() => handleDetailsOrder(order)}
                                                >
                                                    לצפייה בהזמנה
                                                </Button>
                                            </TableCell>
                                            <TableCell>
                                                <IconButton
                                                    color="error"
                                                    onClick={() => handleDeleteOrder(order.id)}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </TableCell>

                                        </TableRow>
                                    ))}
                                    {filteredOrders.length === 0 && (
                                        <TableRow>
                                            <TableCell colSpan={5} align="center">
                                                אין הזמנות שבוצעו עדיין
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
};

export default CompletedOrders;
